import deactivateCharm from '../actions/deactivateCharm';
import hideQuickOptionsAction from 'owa-options-actions/lib/hideQuickOptions';
import { orchestrator } from 'satcheljs';
export default orchestrator(hideQuickOptionsAction, function hideSettings() {
    deactivateCharm(4 /* SettingsCharm */);
});
//# sourceMappingURL=deactivateSettingsCharm.js.map